"use client";

import { c as _c } from "react/compiler-runtime";
import { createReply } from "@/actions/comment";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { queryClient } from "@/providers/react-query";
import { TContentType } from "@/types/types";
import { commentCreateSchema } from "@/types/zod-types";
import { tryCatch } from "@/utils/validators";
import { useAuth } from "@clerk/nextjs";
import { zodResolver } from "@hookform/resolvers/zod";
import { SendHorizonal } from "lucide-react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { z } from "zod";
type ReplyFormProps = {
  contentType: TContentType;
  contentId: string;
  parentCommentId: string;
  hideReplyForm: () => void;
};
export default function ReplyForm(t0) {
  const $ = _c(25);
  const {
    contentType,
    contentId,
    parentCommentId,
    hideReplyForm
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      resolver: zodResolver(commentCreateSchema),
      defaultValues: {
        content: ""
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const form = useForm(t1);
  const {
    control,
    handleSubmit,
    reset,
    formState: t2
  } = form;
  const {
    isDirty,
    isSubmitting
  } = t2;
  const {
    userId
  } = useAuth();
  let t3;
  if ($[1] !== contentId || $[2] !== contentType || $[3] !== hideReplyForm || $[4] !== parentCommentId || $[5] !== reset || $[6] !== userId) {
    t3 = async function handleCreateReply(formData) {
      if (!userId) {
        toast.warning("Please sign in to add a reply.");
        return;
      }
      const {
        error
      } = await tryCatch(createReply(contentType, contentId, parentCommentId, formData));
      if (error) {
        toast.error(error.message);
        return;
      }
      reset();
      hideReplyForm();
      queryClient.invalidateQueries({
        queryKey: [`get-comments:${contentType}:${contentId}`]
      });
      toast.success("Reply added.");
    };
    $[1] = contentId;
    $[2] = contentType;
    $[3] = hideReplyForm;
    $[4] = parentCommentId;
    $[5] = reset;
    $[6] = userId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleCreateReply = t3;
  let t4;
  if ($[8] !== handleCreateReply || $[9] !== handleSubmit) {
    t4 = handleSubmit(handleCreateReply);
    $[8] = handleCreateReply;
    $[9] = handleSubmit;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== control) {
    t5 = <FormField control={control} name="content" render={_temp} />;
    $[11] = control;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = !isDirty || isSubmitting;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SendHorizonal size={20} />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6) {
    t8 = <Button type="submit" disabled={t6} className="h-auto self-stretch">{t7}</Button>;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t5 || $[17] !== t8) {
    t9 = <div className="flex items-center gap-2">{t5}{t8}</div>;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t4 || $[20] !== t9) {
    t10 = <form onSubmit={t4}>{t9}</form>;
    $[19] = t4;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== form || $[23] !== t10) {
    t11 = <Form {...form}>{t10}</Form>;
    $[22] = form;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}
function _temp(t0) {
  const {
    field
  } = t0;
  return <FormItem><FormControl><Input {...field} value={field.value || ""} placeholder="Add your reply..." /></FormControl></FormItem>;
}